import {useScrollSection} from "react-scroll-section";
import {Col, Image, Row, Typography, Dropdown, Menu} from "antd";
import logo from "../../utils/logo-vr.png";
import React from "react";
import './header.css';
import { UnorderedListOutlined } from '@ant-design/icons';

const { Text } = Typography;

const Header = () => {
    const homeSection = useScrollSection('home');
    const aboutSection = useScrollSection('about');
    const partnersSection = useScrollSection('partners');
    const contactsSection = useScrollSection('contacts');
    const productsSection = useScrollSection('products');
    const isMobile = window.screen.width < 769;

    const menu = (
        <Menu selectable={false}>
                <Menu.Item key="two" >
                    <Text
                        style={{ fontSize: 14}}
                        onClick={homeSection.onClick}
                        selected={homeSection.selected}
                    >
                        ГЛАВНАЯ
                    </Text>
                </Menu.Item>
                <Menu.Item key="three">
                    <Text
                        style={{ fontSize: 14}}
                        onClick={aboutSection.onClick}
                        selected={aboutSection.selected}
                    >
                        О НАС
                    </Text>
                </Menu.Item>
                <Menu.Item>
                    <Text
                        style={{ fontSize: 14}}
                        onClick={productsSection.onClick}
                        selected={productsSection.selected}
                    >
                        ПРОДУКТЫ
                    </Text>
                </Menu.Item>
                <Menu.Item>
                    <Text
                        style={{ fontSize: 14}}
                        onClick={partnersSection.onClick}
                        selected={partnersSection.selected}
                    >
                        ПАРТНЕРЫ
                    </Text>
                </Menu.Item>
                <Menu.Item>
                    <Text
                        style={{ fontSize: 14}}
                        onClick={contactsSection.onClick}
                        selected={contactsSection.selected}
                    >
                        КОНТАКТЫ
                    </Text>
                </Menu.Item>
        </Menu>
    );

    return (
        <Row justify="space-between" className="header-row montserrat">
            {isMobile ?
                <>
                    <Col span={12}>
                        <Image preview={false} src={logo}/>
                    </Col>
                    <Col span={12}>
                        <Row justify="end"  style={{ alignItems: 'center', height: '100%'}}>
                            <Dropdown overlay={menu} arrow={false} trigger={['click']} placement="bottomRight">
                                <UnorderedListOutlined style={{color: 'black', fontSize: '6vw'}}/>
                            </Dropdown>
                        </Row>
                    </Col>
                </>
                :
                <>
                    <Col span={6}>
                        <Image preview={false} src={logo}/>
                    </Col>
                    <Col span={18} style={{textAlign: 'right', margin: 'auto'}}>
                        <Row justify="end">
                            <div className="navTab" >
                                <Text
                                    style={{lineHeight: '33px', fontSize: 18}}
                                    onClick={homeSection.onClick}
                                    selected={homeSection.selected}
                                >
                                    ГЛАВНАЯ
                                </Text>
                            </div>
                            <div className="navTab" >
                                <Text
                                    style={{lineHeight: '33px', fontSize: 18}}
                                    onClick={aboutSection.onClick}
                                    selected={aboutSection.selected}
                                >
                                    О НАС
                                </Text>
                            </div>
                            <div className="navTab" >
                                <Text
                                    style={{lineHeight: '33px', fontSize: 18}}
                                    onClick={productsSection.onClick}
                                    selected={productsSection.selected}
                                >
                                    ПРОДУКТЫ
                                </Text>
                            </div>
                            <div className="navTab" >
                                <Text
                                    style={{lineHeight: '33px', fontSize: 18}}
                                    onClick={partnersSection.onClick}
                                    selected={partnersSection.selected}
                                >
                                    ПАРТНЕРЫ
                                </Text>
                            </div>
                            <div className="navTab" >
                                <Text
                                    style={{lineHeight: '33px', fontSize: 18}}
                                    onClick={contactsSection.onClick}
                                    selected={contactsSection.selected}
                                >
                                    КОНТАКТЫ
                                </Text>
                            </div>
                        </Row>
                    </Col>
                </>
            }
        </Row>
    );
};

export default Header;